import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

// countries.registerLocale(require('i18n-iso-countries/langs/hu.json'));

export default {
  unixTs: dayjs()
    .utcOffset(120)
    .unix(),
  curveColors: {
    ssh: '#17e046',
    firewall: '#e6e12f',
    http: '#e73a39',
    smtp: '#0CB3E4',
    pop3: '#ef7c38',
    imap: '#e23096',
    dns: '#854896'
  }
};
